import { BOOLEAN_CHOICES } from 'elements/filtering/types'
import lodash from 'lodash'
import { FC, ReactNode, useEffect, useMemo } from 'react'
import { SelectInput } from 'react-admin'
import { useForm, useFormState } from 'react-final-form'

interface PropTypes {
  source: string
  fieldId: string
  onChange: (value: { conditional?: boolean; itemId?: unknown }) => object
  children: ReactNode
}

const ConditionalRefFilter: FC<PropTypes> = ({ source, onChange, children }) => {
  const form = useForm()
  const formValues = useFormState().values
  const filterField = useMemo(() => lodash.get(formValues, `${source}.fields`), [formValues, source])

  useEffect(() => {
    const newValue = onChange(filterField)
    form.change(`${source}.value`, newValue)
  }, [filterField, source, onChange, form])

  return (
    <>
      <SelectInput
        choices={BOOLEAN_CHOICES}
        label={false}
        source={`${source}.fields.conditional`}
        variant="outlined"
        margin={'none'}
        style={{ minWidth: '100px' }}
      />
      {children}
    </>
  )
}

export default ConditionalRefFilter

